module.exports = __webpack_public_path__ + "static/media/home-img-3.915ee075.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/intro/home-img-3.svg
// module id = 668
// module chunks = 0